<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20">
      <el-breadcrumb-item>积分管理</el-breadcrumb-item>
      <el-breadcrumb-item>积分商品</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <!-- <el-form
      label-width="110px"
      :model="formInline"
      :rules="formInlineRules"
      v-show="isShowSearch"
      class="user-search"
    >
          <div class="search_formul">
            <div class="search_formli">
            <el-form-item label="商品名称">
              <el-input
                size="small"
                clearable
                v-model="formInline.name"
                placeholder="请输入商品名称"
              ></el-input>
            </el-form-item>
          </div>
            <div class="search_formli">
              <el-form-item label="商品类型">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formInline.source"
                  placeholder="请选择商品类型"
                >
                  <el-option
                    v-for="item in sourceOptions"
                    :key="item.id + '-smlxkey'"
                    :label="item.key"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
            </el-form-item>
            </div>
            <div class="search_formli">
          <el-form-item label="商品来源">
            <el-select
              size="small"
              clearable
              filterable
              v-model="formInline.flag"
              placeholder="请选择商品来源"
            >
              <el-option
                v-for="item in productSource"
                :key="item.value + '-splykey'"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
            </div>
            <div class="search_formli">
  <el-form-item label="产品分类">
            <el-select
              size="small"
              clearable
              filterable
              v-model="formInline.classificationId"
              placeholder="请选择产品分类"
            >
              <el-option
                v-for="item in proTypeListOption"
                :key="item.id + '-flkey'"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            </div>
            <div class="search_formli">
  <el-form-item label="是否推荐">
            <el-select
              size="small"
              clearable
              v-model="formInline.isRecommend"
              placeholder="请选择商品是否推荐"
            >
              <el-option
                v-for="item in isRecommendOptions"
                :key="item.value + '-isrecmkey'"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
            </div>
          </div>
          <div class="search_formul">
            <div class="search_formli">
  <el-form-item label="是否下架">
            <el-select
              size="small"
              clearable
              v-model="formInline.underCarriage"
              placeholder="请选择商品是否下架"
            >
              <el-option
                v-for="item in underCarriages"
                :key="item.value + '-carrkey'"
                :label="item.key"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
            </div>
            <div class="search_formli">
  <el-form-item label="所属国家">
            <el-select
              size="small"
              filterable
              clearable
              v-model="formInline.nationalId"
              placeholder="请选择所属国家"
            >
              <el-option
                v-for="item in nationalOptions"
                :key="item.id + '-natkey'"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
            </div>
            <div class="search_formli start_money">
              <el-form-item label="开始价格" prop="startAmount">
                <el-input-number
                  size="small"
                  :precision="2"
                  clearable
                  class="full_select"
                  v-model="formInline.startAmount"
                  placeholder="请输入开始价格(元)"
                ></el-input-number>
              </el-form-item>
            </div>
            <div class="search_formli end_money">
              <el-form-item label="结束价格" prop="endAmount">
                <el-input-number
                  size="small"
                  :precision="2"
                  class="full_select"
                  clearable
                  v-model="formInline.endAmount"
                  placeholder="请输入结束价格(元)"
                ></el-input-number>
              </el-form-item>
            </div>
            <div class="search_formli btn_group">
              <el-form-item>
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-search"
              @click="search"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-refresh"
              @click="resetFormLine"
              >清空</el-button
            >
          </el-form-item>
            </div>
           </div>
    </el-form> -->
    <el-row class="mb20">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="商品名称">
          <el-input size="small" v-model="formInline.name" clearable placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品ID">
          <el-input size="small" v-model="formInline.thirdGoodId" clearable placeholder="请输入商品ID"></el-input>
        </el-form-item>
        <el-form-item label="消耗积分">
          <el-input size="small" v-model="formInline.redemptionPoints" clearable placeholder="请输入消耗积分"></el-input>
        </el-form-item>
<!--        <el-form-item label="兑换价格">-->
<!--          <el-input size="small" v-model="formInline.exchangePrice" clearable placeholder="请输入兑换价格"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row style="margin-bottom: 10px">
      <el-button size="small"  plain type="danger"
                 @click="deleteProduct()" :disabled="isGroundingBtn">批量删除</el-button>
    </el-row>
<!-- <div class="hide_search_box">
    <el-tooltip class="hide_search" effect="dark" :content="!isShowSearch?'显示搜索':'隐藏搜索'" placement="top-start">
        <el-button icon="el-icon-search" size="small"
        type="primary"
        plain
        @click="hideSearch" circle></el-button>
    </el-tooltip>
</div> -->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      @selection-change="selectChange"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
    <!-- <el-table-column align="center" type="selection" width="50">
     </el-table-column> -->
      <!-- <el-table-column
        label="商品来源"
        align="center"
        show-overflow-tooltip
        width="150"
      >
        <template slot-scope="scope">
          {{ getThirdFlag(scope.row.thirdFlag) }}
        </template>
      </el-table-column> -->
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column
        prop="name"
        label="商品名称"
        align="center"
        min-width="200"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="redemptionPoints"
        label="消耗积分"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="exchangePrice"
        label="兑换价格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="thirdGoodId"
        label="商品ID"
        min-width="200"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        sortable
        prop="interAmount"
        label="成本价格"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="amount"
        label="商品价格"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="vipAmount"
        label="会员价格"
        align="center"
        width="100"
      >
      </el-table-column> -->
      <!-- <el-table-column label="产品分类" show-overflow-tooltip align="center">
        <template slot-scope="scope">
          {{
            getDictKeyById(
              proTypeListOption,
              scope.row.classificationId,
              "name"
            )
          }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column align="center" min-width="120px" label="接口商品类型">
      <template slot-scope="scope">
        {{ typeNameList[scope.row.interGoodType*1] }}
      </template>
     </el-table-column> -->
      <!-- <el-table-column label="生产厂家" align="center">
        <template slot-scope="scope">
          {{ getDictKeyById(factorOptions, scope.row.manufactor, "key") }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="产品标签" align="center">
        <template slot-scope="scope">
          <el-tag
            style="marginright: 10px; marginbottom: 10px"
            size="mini"
            v-for="id in scope.row.flagList"
            :key="id.name+'cpbq'"
          >
            {{ getDictKeyById(flagOptions, id, "key") }}
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="产品图片" min-width="200">
        <template slot-scope="scope">
          <div class="imgarea">
            <el-image
            class="table-img"
            v-for="imgoss in scope.row.detailImageOss"
            :key="imgoss"
            style="width: 36px; height: 24px"
            :src="imgoss"
            :preview-src-list="[imgoss]"
          >
          </el-image>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="是否推荐" min-width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isRecommend"
            @change="recommendChange($event, scope.row)"
            :active-value="0"
            size="mini"
            :inactive-value="1"
          >
          </el-switch>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="是否上架" min-width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.underCarriage"
            @change="underCarriageChange($event, scope.row)"
            :active-value="1"
            size="mini"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="商品类型">
        <template slot-scope="scope">
          {{ getDictKeyById(sourceOptions, scope.row.source, "key") }}
        </template>
      </el-table-column> -->

      <!-- <el-table-column prop="nationalName" label="所属国家"> </el-table-column> -->
      <!-- <el-table-column prop="totalNum" label="产品总数量"> </el-table-column> -->
      <!-- <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.createDate | timestampToTime }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="updateDate" label="修改时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.updateDate | timestampToTime }}</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="操作" width="240" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(999, scope.row)"
            >查看</el-button
          >
          <el-button
            size="mini"
            @click="handleIntegral(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteProduct(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-drawer
      :title="title"
      :visible.sync="editFormVisible"
      size="70%"
      @close="closeDialog('editForm')"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        ref="editForm"
        :rules="rules"
        :disabled="disabled"
      >
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="商品名称" prop="name">
              <el-input
                size="small"
                v-model="editForm.name"
                auto-complete="off"
                placeholder="请输入商品名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="商品价格" prop="amount">
              <el-input-number
                size="small"
                :precision="2"
                style="width: 100%"
                clearable
                v-model="editForm.amount"
                placeholder="请输入商品价格(元)"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="产品总数量" prop="totalNum">
              <el-input
                size="small"
                @input="
                  editForm.totalNum = editForm.totalNum.replace(
                    /^(0+)|[^\d]+/g,
                    ''
                  )
                "
                clearable
                v-model="editForm.totalNum"
                placeholder="请输入产品总数量"
              >
                <template #append>
                  <span>件</span>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="会员价格" prop="vipAmount">
              <el-input-number
                size="small"
                style="width: 100%"
                :precision="2"
                clearable
                v-model="editForm.vipAmount"
                placeholder="请输入会员价格(元)"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="产品分类" prop="classificationId">
              <el-select
                size="small"
                clearable
                filterable
                class="full_select"
                v-model="editForm.classificationId"
                placeholder="请选择产品分类"
              >
                <el-option
                  v-for="item in proTypeListOption"
                  :key="item.id + '-typekey'"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="产品标签" prop="flagList">
              <el-select
                size="small"
                class="full_select"
                multiple
                clearable
                filterable
                v-model="editForm.flagList"
                placeholder="请选择产品标签"
              >
                <el-option
                  v-for="item in flagOptions"
                  :key="item.id + '-flagkey'"
                  :label="item.key"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="商品类型" prop="source">
              <el-select
                size="small"
                class="full_select"
                clearable
                filterable
                v-model="editForm.source"
                placeholder="请选择商品类型"
              >
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.id + '-seltypekey'"
                  :label="item.key"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="生产厂家" prop="manufactor">
              <el-select
                size="small"
                class="full_select"
                clearable
                filterable
                v-model="editForm.manufactor"
                placeholder="请选择生产厂家"
              >
                <el-option
                  v-for="item in factorOptions"
                  :key="item.id + '-fackey'"
                  :label="item.key"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="所属国家" prop="nationalId">
              <el-select
                size="small"
                class="full_select"
                filterable
                v-model="editForm.nationalId"
                placeholder="请选择所属国家"
              >
                <el-option
                  v-for="item in nationalOptions"
                  :key="item.id + '-selnationkey'"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="品牌" prop="brand">
              <el-select
                size="small"
                filterable
                class="full_select"
                v-model="editForm.brand"
                placeholder="请选择品牌"
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.id + '-ppkey'"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="成本价格" prop="interAmount">
              <el-input-number
                size="small"
                :precision="2"
                style="width: 100%"
                clearable
                v-model="editForm.interAmount"
                placeholder="请输入成本价格(元)"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="产品图片" prop="detailImage">
              <el-upload
                :class="{ uoloadSty: showBtnDealImg, disUoloadSty: noneBtnImg }"
                ref="detailImageUpload"
                action="#"
                list-type="picture-card"
                :file-list="fileList"
                :limit="limitCountImg"
                :before-upload="beforeAvatarUpload"
                :on-change="swiperImgChange"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="img_size_tip">
                  避免影响小程序内显示效果，请上传：1/1比例图片
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-row>
            <el-col :span="12">
              <el-form-item label="简介" prop="adaptationDisease">
                <el-input
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model="editForm.adaptationDisease"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <local-quill-editor :content="editForm.description" :isdisabled="!!disabled" @editChange="editChange"></local-quill-editor> -->
          <el-col :span="24">
            <el-form-item label="商品描述" prop="description">
              <editor v-model="editForm.description" :min-height="192" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        class="dr-footer"
        style="text-align: center"
        v-if="disabled == false"
      >
        <el-button size="small" @click="closeDialog('editForm')"
          >取消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-drawer>
    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="integralFormVisible" width="20%" @click="closeDialog('editForm')">
        <el-form label-width="120px" :model="integralForm" ref="integralForm" :rules="integralFormRules">
              <el-form-item label="兑换积分" prop="redemptionPoints">
                <el-input-number
                  size="small"
                  :precision="2"
                  style="width: 100%"
                  clearable
                  :step="100"
                  :min="0"
                  @change="changeVal"
                  v-model="integralForm.redemptionPoints"
                  placeholder="请输入兑换积分"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="兑换价格" prop="exchangePrice">
                <el-input-number
                  size="small"
                  :precision="2"
                  style="width: 100%"
                  clearable
                  @change="changeVal"
                  v-model="integralForm.exchangePrice"
                  placeholder="请输入兑换价格"
                ></el-input-number>
              </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="closeintegralDialog('integralForm')">取消</el-button>
              <el-button size="small" type="primary" :loading="loading" class="title" @click="submitIntegralForm('editForm')">保存</el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import {
  GoodsList,
  GoodsSave,
  GoodsDelete,
  GoodsEdit,
  GoodsRecommend,
  underCarriage,
  setRecommend,
  getClassiFicationTypeList,
  getRoleList,
  exportProduct,
  vipProductList,
  updateVipProduct,
  delVipProduct
} from "../../api/basisMG";
import { upimg } from "@/api/userMG";
import { Loading } from 'element-ui'
import Pagination from "../../components/Pagination";
import { getDictByTypeId } from "@/api/system";
import exportFile from '@/utils/exportFile'
export default {
  data() {
    return {
      disabled: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      integralFormVisible: false,
      integralForm:{},
      title: "预览",
      noneBtnImg: false, //图片按钮显示隐藏
      showBtnDealImg: true,
      isShowSearch:true,
      limitCountImg: 4,
      dialogImageUrl: "",
      detailImageArr: [],
      typeNameList:['一般贸易','保税','海外直邮'],
      fileList: [],
      dialogVisible: false,
      sourceOptions: [],
      factorOptions: [],
      flagOptions: [],
      nationalOptions: [],
      proTypeListOption: [],
      brandOptions: [],
      isRecommendOptions: [
        { label: "是", value: 0 },
        { label: "否", value: 1 },
      ],
      productSource: [
      ],
      underCarriages: [
        { key: "是", value: 0 },
        { key: "否", value: 1 },
      ],
      nationalImageUrl: "",
      coverImageUrl: "",
      detailImage: "",
      uploadheaders: {
        Authorization: localStorage.getItem("logintoken"),
      },
      integralFormRules:{
        redemptionPoints: [
          { required: true, message: "请输入兑换积分", trigger: "blur" },
          {
            type: "number",
            min: 100,
            max: 999999,
            message: `请输入6位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        exchangePrice:[
          { required: true, message: "请输入兑换价格", trigger: "blur" },
          {
            type: "number",
            min: 1,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
      },
      rules: {
        name: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          { whitespace: true, message: "只存在空格", trigger: "blur" },
        ],
        amount: [
          { required: true, message: "请输入商品价格", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        interAmount: [
          { required: true, message: "请输入成本价格", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        totalNum: [
          { required: true, message: "请输入产品总数量", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        vipAmount: [
          { required: true, message: "请输入会员价格", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        classificationId: [
          { required: true, message: "请选择产品分类", trigger: "change" },
        ],
        // flagList:[ { required: true, message: '请选择产品标签', trigger: 'blur' },],
        source: [
          { required: true, message: "请选择商品类型", trigger: "change" },
        ],

        // manufactor:[ {required: true, message: '请选择生产厂家', trigger: 'change'} ],
        description: [
          { required: true, message: "请输入药品描述", trigger: "blur" },
        ],
        brand: [{ required: true, message: "请选择品牌", trigger: "change" }],
        imageUrlOss: [
          { required: true, message: "请添加推荐封面图片", trigger: "change" },
        ],
        // adaptationDisease:[ { required: true, message: '请输入药品适应症', trigger: 'blur' },],
        nationalId: [
          { required: true, message: "请选择所属国家", trigger: "change" },
        ],
        detailImage: [
          { required: true, message: "请添加药品详情图片", trigger: "change" },
        ],
      },
      formInlineRules: {
        startAmount: [
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        endAmount: [
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
      },
      editForm: {
        name: "",
        amount: "",
        totalNum: null,
        vipAmount: "",
        classificationId: "",
        flagList: "",
        source: "",
        manufactor: "",
        description: "",
        brand: "",
        imageUrlOss: "",
        adaptationDisease: "",
        nationalId: "",
        detailImage: "",
      },
      formInline: {
        page: 1,
        limit: 10,
        isPointsMall:1, //积分商品
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      isGroundingBtn:true, //批量按钮禁用
      ids:'',
    };
  },
  // 注册组件
  components: {
    Pagination,
    // LocalQuillEditor
  },
  created() {
    this.getdata(this.formInline);
    this.getDictByTypeId();
    this.getDict()
  },
  methods: {
    // 展示隐藏搜索
    hideSearch(){
      this.isShowSearch = !this.isShowSearch
    },
    //获取字典数据
    getDict() {
      this.getDictById(32)
    },
    async getDictById(id) {
      const {body} =  await getDictByTypeId(id)
      this.productSource = body
    },
    // selection选择
    selectChange(selection){
      console.log('selection',selection);
        if(selection.length>0){
            this.isGroundingBtn = false
        }else{
            this.isGroundingBtn = true
        }
        let ids;
        ids = selection.map(item => item.id)
        this.ids = ids.join()
    },

    resetForm() {
      // this.$nextTick(() => {
      //   this.$refs['editForm'].clearValidate();
      //   this.$refs['editForm'].resetFields()
      // });
      this.detailImageArr = []; //清除保存图片No的数组缓存 避免连续上传重复
      this.editForm = {
        name: "",
        amount: "",
        totalNum: null,
        vipAmount: "",
        classificationId: "",
        flagList: "",
        source: "",
        manufactor: "",
        description: "",
        brand: "",
        imageUrlOss: "",
        adaptationDisease: "",
        nationalId: "",
        detailImage: "",
      };
    },
    resetFormLine() {
      this.formInline = {
        page: 1,
        limit: 10,
      };
    },
    changes(value) {
      // if(value > this.max) {
      this.editForm.vipAmount = value;
      // }
    },
    resetintegralForm(){
      this.integralForm.exchangePrice = 0
      this.integralForm.redemptionPoints = 0
    },
    handleIntegral(i,row){
      this.resetintegralForm()
      this.integralForm.exchangePrice = row.exchangePrice
      this.integralForm.redemptionPoints = row.redemptionPoints
      this.integralForm.id = row.id
      this.integralFormVisible=true
    },
    submitIntegralForm(){
      // console.log(this.integralForm.redemptionPoints);
      if(this.integralForm.redemptionPoints % 100 !== 0 ){
         this.$message.warning('积分数只能是100的倍数！');
      }
      else if(this.integralForm.redemptionPoints < 100){
         this.$message.warning('积分数只能是100的倍数！');
      }else if(this.integralForm.exchangePrice < 1){
        this.$message.warning('兑换金额不能小于1');
      }
      else{
        updateVipProduct(this.integralForm).then(res=>{
          if(res.rsp_code==200){
            this.$message.success('编辑成功');
            this.integralFormVisible=false
            this.getdata(this.formInline);
          }else{
            this.$message.error(res.rsp_code);
          }
        })
      }
    },
    // 多图预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    swiperImgChange(file, fileList) {
      this.fileList = fileList;
      this.noneBtnImg = fileList.length >= this.limitCountImg;
    },
    beforeAvatarUpload(file) {
      // console.log(file,'图片文件before');
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("只能上传jpg或png格式!");
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
      // return isLt2M;
    },
    // 富文本内容
    editChange(e) {
      // console.log(e,'富文本change时的值');
      this.editForm.description = e.html;
    },
    // 获取列表
    getdata(parameter) {
      this.loading = true;
      vipProductList(parameter).then((res) => {
          this.loading = false;
          if (res.rsp_code !== 200) {
            this.$message({
              type: "info",
              message: res.rsp_msg,
            });
          } else {
            this.listData = res.body.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page;
            this.pageparm.pageSize = this.formInline.limit;
            this.pageparm.total = res.body.total;
          }
        })
        .catch((err) => {
          callFather;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row, typeName) {
      this.editFormVisible = true;
      this.disabled = false;
      this.fileList = [];
      this.resetForm();
      if (index == 999) {
        this.title = "查看";
        this.disabled = true;
        this.editForm = row;
        for (
          let index = 0;
          index < this.editForm.detailImageOss.length;
          index++
        ) {
          this.fileList.push({ url: this.editForm.detailImageOss[index] });
        }
        this.noneBtnImg = true;
      } else {
        if (row != undefined && row != "undefined") {
          this.title = "修改";
          this.editForm = row;
          let imgArr = row.detailImage.split(";");
          for (
            let index = 0;
            index < this.editForm.detailImageOss.length;
            index++
          ) {
            this.fileList.push({ url: this.editForm.detailImageOss[index] });
            this.detailImageArr.push(imgArr[index]);
          }
          this.noneBtnImg = this.fileList.length >= this.limitCountImg;
        } else {
          this.noneBtnImg = false;
          this.title = "添加";
          this.editForm = {
            name: "",
            description: "",
            // listImgNoOss:'',nationalOss:'',imageUrlOss:'',
            detailImageOss: "",
          };
          this.fileList = [];
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          let subType = this.title == "添加" ? GoodsSave : GoodsEdit;
          if(this.editForm.flagList&&this.editForm.flagList.length>0){
            this.editForm.flag = this.editForm.flagList.join(";");
          }
          subType(this.editForm)
            .then((res) => {
              this.loading = false;
              if (res.rsp_code == 200) {
                this.getdata(this.formInline);
                this.editFormVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.rsp_msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("保存失败，请稍后再试！");
            });
        } else {
          // return false
          this.moveToErr();
        }
      });
    },
    // 滑动到未
    moveToErr() {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName("is-error");
        if (isError.length) {
          isError[0].scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          // 这个当滑动到报错项之后自动获取输入框的焦点，方便用户直接进行输入，延迟 800ms 是因为需要都能到定位成功后在进行获取焦点体验更好一些
          setTimeout(() => {
            if (isError[0].previousElementSibling.querySelector("input")) {
              isError[0].previousElementSibling.querySelector("input").focus();
            }
          }, 800);
        }
      });
    },
    // 获取药品来源字典
    getDictByTypeId() {
      getDictByTypeId(2).then((res) => {
        this.sourceOptions = res.body;
      });
      getDictByTypeId(8).then((res) => {
        this.flagOptions = res.body;
      });
      getDictByTypeId(10).then((res) => {
        this.factorOptions = res.body; //生产厂家
      });
      getDictByTypeId(11).then((res) => {
        this.brandOptions = res.body; //品牌
      });
      getClassiFicationTypeList().then((res) => {
        this.proTypeListOption = res.body; // 获取分类下拉列表
      });
      getRoleList().then((res) => {
        this.nationalOptions = res.body;
      });
    },
    // 删除公司
    deleteProduct(index, row) {
      let that = this;
      console.log(that.ids)
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = row ?  row.id:that.ids;
          console.log(ids)
          delVipProduct(ids)
            .then((res) => {
              if (res.rsp_code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.rsp_msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      // this.getdata(this.formInline);
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
    // 关闭编辑、增加弹出框
    closeintegralDialog(formName) {
      this.integralForm = {}
      this.integralFormVisible = false;
    },
    // 根据字典id获取字典key
    getDictKeyById(options, id, keyString) {
      let key = "";
      options.forEach((item) => {
        if (item.id * 1 == id * 1) {
          key = item[keyString];
        }
      });
      return key;
    },
    getThirdFlag(flag) {
      let text = "";
      if (flag != null) {
        text = this.productSource[flag].label;
      } else {
        text = "私有";
      }
      return text;
    },
    changeVal() {
      this.$forceUpdate();//解决点击计数器失效问题
    },
  },
};
</script>
<style>
.hide_search_box{
  position: relative;
  margin-top: 60px;
}
.hide_search{
  position: absolute;
  top: -50px;
  right: 20px;
}
.ql-container {
  height: 80%;
}
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
.el-upload__tip {
  line-height: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/* 上传按钮显示隐藏 */
.uoloadSty .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.disUoloadSty .el-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}
.el-drawer__body {
  overflow-x: hidden;
  padding-right: 20px;
  padding-bottom: 60px;
}
.el-drawer__body::-webkit-scrollbar {
  height: 10px;
  width: 12px;
}
.el-drawer__body::-webkit-scrollbar-thumb {
  background: rgb(55, 88, 236);
}
.dr-footer {
  padding: 20px 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #ffffff;
}
</style>
<style scoped>
.table-img {
  margin: 0 5px;
}
::v-deep .el-dialog__body {
  padding-bottom: -1px;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/integralManage/integralList.vue